import { Button, Heading } from '@chakra-ui/react';

import { Link, VStack } from '@/components';

export const NotFound = () => {
  return (
    <VStack className="NotFound" padding={4}>
      <Heading>Not Found</Heading>

      <Link asChild to="/">
        <Button colorPalette="accent" pill>
          Home
        </Button>
      </Link>
    </VStack>
  );
};
